import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';

// native
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  public rootPage: any = 'home';

  constructor(
    platform: Platform,
    splashScreen: SplashScreen,
    statusBar: StatusBar,
    insomnia: Insomnia) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.hide();
      splashScreen.hide();

      insomnia.keepAwake()
        .then(() => {
          console.log('keep awake: activated!');
        })
        .catch((error) => {
          console.log('keep awake failed: ' + error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts